import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=5056bfcc&scoped=true&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/loading.css?vue&type=style&index=0&id=5056bfcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056bfcc",
  null
  
)

export default component.exports